import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    // You can return a loading spinner or null while checking auth state
    return <div>Loading...</div>;
  }

  return currentUser ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
